export enum Routes {
  SERVICEABILITY = '',
  PLAN = 'pln',
  ADDONS = 'adds',
  PERSONAL_INFORMATION = 'prsnlInf',
  CREDIT_CHECK = 'cc',
  SCHEDULE_INSTALLATION = 'schdInst',
  PAYMENT_INFORMATION = 'pmntInf',
  ORDER_SUMMARY = 'ordSum',
  ERROR = 'err',
  PLAN_GRID = 'plnGrd',
  PLAN_DETAILS = 'plnDtl',
  DISCLOSURES = 'dsclsrs',
}

export const RoutesToNamespaces: { [key: string]: string } = {
  pln: 'plan',
  adds: 'addons',
  prsnlInf: 'personalInformation',
  cc: 'creditCheck',
  schdInst: 'scheduleInstallation',
  pmntInf: 'paymentInformation',
  ordSum: 'orderSummary',
  err: 'error',
  plnGrd: 'planGrid',
  plnDtl: 'planDetails',
  dsclsrs: 'disclosures',
};

type RouteState = {
  Next?: Routes;
  Previous?: Routes;
  Reset?: Routes;
  order: number;
};

export type RouteStates = Record<Routes, RouteState>;

export type RouteContext = {
  skipCreditCheck: boolean;
  skipAddons: boolean;
  skipDisclosures: boolean;
};

export type NavState = {
  currentAppRoute: Routes;
  routeStates: RouteStates | null;
  maxRoute: Routes;
  currentStep: number;
  totalSteps: number;
  routeSequence: Routes[];
  routeContext: RouteContext | null;
};

export const routesIntlMapping: Record<string, string> = {
  [Routes.PLAN]: 'plan',
  [Routes.ADDONS]: 'addons',
  [Routes.PERSONAL_INFORMATION]: 'personalInformation',
  [Routes.CREDIT_CHECK]: 'creditCheck',
  [Routes.SCHEDULE_INSTALLATION]: 'scheduleInstallation',
  [Routes.PAYMENT_INFORMATION]: 'paymentInformation',
  [Routes.ORDER_SUMMARY]: 'orderSummary',
  [Routes.ERROR]: 'error',
};

export enum COOKIE_NAME {
  dealerId = 'DID',
  partnerId = 'PAID',
  userLDKey = 'LDKEY',
  addressLine1 = 'addressLine1',
  addressLine2 = 'addressLine2',
  postalCode = 'postalCode',
}
